import { api } from '@/services/axios'

export async function signOut(refreshToken: string) {
  try {
    const response = await api.post('Auth/logout', { refreshToken })
    return response.data
  } catch (error) {
    console.error('Erro ao fazer logout:', error)
    throw error
  }
}
